/* DemoPool free tool: email list checker v2 (10.10.2026).
   Calls Ninja Digger POST /api/v1/tools/email-check {emails:[...]} (max 10; 3/min, 10/day per IP).
   No SMTP on that endpoint; nothing is stored. UI: one field, one button, summary + compact list. */
(function () {
  'use strict';
  var API = 'https://ninja-digger.vercel.app/api/v1/tools/email-check';
  var MAX = 10, TIMEOUT = 15000;

  // status -> [tone, short reason shown under the address ('' = none)]
  var S = {
    valid_domain: ['ok', ''],
    verified_in_db: ['ok', 'In DemoPool lists, mail server checked'],
    role: ['warn', 'Shared inbox, read last'],
    unknown: ['warn', "Mail server didn't answer"],
    disposable: ['bad', 'Throwaway address'],
    no_mx: ['bad', 'Domain has no mail server'],
    invalid_syntax: ['bad', 'Not a valid address']
  };
  var BADGE = { ok: 'Good', warn: 'Risky', bad: 'Dead' };
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Split pasted text into unique address-like tokens. Accepts "Name <a@b.com>", mailto:, commas, semicolons, new lines.
  function parse(text) {
    var seen = {}, list = [], dupes = 0, skipped = 0;
    String(text || '').split(/[\s,;]+/).forEach(function (t) {
      t = t.replace(/^mailto:/i, '').replace(/^[<("'\[]+|[>)"'\].:]+$/g, '');
      if (!t) return;
      if (t.indexOf('@') < 0) { skipped++; return; }
      var k = t.toLowerCase();
      if (seen[k]) { dupes++; return; }
      seen[k] = 1; list.push(t);
    });
    return { list: list, dupes: dupes, skipped: skipped };
  }

  function summarize(results) {
    var c = { ok: 0, warn: 0, bad: 0 };
    results.forEach(function (r) { c[(S[r.status] || S.unknown)[0]]++; });
    return { total: results.length, ok: c.ok, risky: c.warn, dead: c.bad };
  }

  function fmtDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); if (!m) return '';
    return MON[+m[2] - 1] + ' ' + (+m[3]) + ', ' + m[1];
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { parse: parse, summarize: summarize, fmtDate: fmtDate, S: S }; return; }

  var $ = function (id) { return document.getElementById(id); };
  var form = $('ec-form'); if (!form) return;
  var ta = $('ec-in'), cnt = $('ec-count'), trim = $('ec-trim'), go = $('ec-go'), out = $('ec-out');
  var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); };
  var busy = false, wait = 0, timer = null, good = [];

  function update() {
    var p = parse(ta.value), n = p.list.length;
    cnt.textContent = Math.min(n, MAX) + ' of ' + MAX;
    cnt.classList.toggle('is-over', n > MAX);
    var bits = [];
    if (n > MAX) bits.push('Only the first ' + MAX + ' will be checked.');
    if (p.dupes) bits.push(p.dupes + (p.dupes > 1 ? ' duplicates' : ' duplicate') + ' removed.');
    trim.textContent = bits.join(' ');
    trim.hidden = !bits.length;
    return p;
  }

  function setBusy(on) {
    busy = on; out.setAttribute('aria-busy', on ? 'true' : 'false');
    go.disabled = on || wait > 0;
    go.textContent = on ? 'Checking…' : wait > 0 ? 'Wait ' + wait + 's' : 'Check';
    go.classList.toggle('is-busy', on);
  }

  function cooldown(sec) {
    clearInterval(timer); wait = sec; setBusy(false);
    timer = setInterval(function () { wait--; if (wait <= 0) { wait = 0; clearInterval(timer); } setBusy(false); }, 1000);
  }

  function show(html) { out.hidden = false; out.innerHTML = html; }

  function msg(html, tone, retry) {
    show('<div class="ec2__msg ec2__msg--' + (tone || 'err') + '" role="alert"><p>' + html + '</p>' +
      (retry ? '<button type="button" class="ec2__copy" data-retry>Try again</button>' : '') + '</div>');
    var r = out.querySelector('[data-retry]'); if (r) r.addEventListener('click', run);
  }

  function render(data, cut) {
    var res = (data && data.results) || [], s = summarize(res);
    good = [];
    var w = function (k) { return s.total ? (100 * s[k] / s.total).toFixed(2) + '%' : '0'; };
    var rows = res.map(function (r) {
      var d = S[r.status] || S.unknown, why = d[1];
      if (d[0] === 'ok') good.push(r.email);
      if (r.status === 'verified_in_db' && r.verified_at) why = 'In DemoPool lists, checked ' + fmtDate(r.verified_at);
      if (r.status === 'valid_domain' && r.role) why = 'Shared inbox, read last';
      return '<li class="ec2__row"><div class="ec2__txt"><p class="ec2__mail">' + esc(r.email) + '</p>' +
        (why ? '<p class="ec2__why">' + esc(why) + '</p>' : '') + '</div><span class="ec2__b is-' + d[0] + '">' + BADGE[d[0]] + '</span></li>';
    }).join('');
    show(
      '<div class="ec2__sumrow"><p class="ec2__sum"><b class="is-ok">' + s.ok + ' good</b><i aria-hidden="true">·</i><b class="is-warn">' + s.risky + ' risky</b><i aria-hidden="true">·</i><b class="is-bad">' + s.dead + ' dead</b></p>' +
      (good.length && good.length < s.total ? '<button type="button" class="ec2__copy" data-copy>Copy good</button>' : '') + '</div>' +
      '<div class="ec2__meter" aria-hidden="true"><i class="is-ok" style="width:' + w('ok') + '"></i><i class="is-warn" style="width:' + w('risky') + '"></i><i class="is-bad" style="width:' + w('dead') + '"></i></div>' +
      (cut ? '<p class="ec2__note">' + cut + ' more not checked. Run them next.</p>' : '') +
      '<ul class="ec2__list" aria-label="Results">' + rows + '</ul>');
    var cp = out.querySelector('[data-copy]');
    if (cp) cp.addEventListener('click', function () {
      var t = good.join('\n'), done = function () { cp.textContent = 'Copied'; setTimeout(function () { cp.textContent = 'Copy good'; }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(t).then(done, function () { ta.value = t; update(); done(); });
      else { ta.value = t; update(); done(); }
    });
    if (out.getBoundingClientRect().top > innerHeight * .8) out.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  function run() {
    if (busy || wait > 0) return;
    var p = update();
    if (!p.list.length) { msg('Paste at least one email, like <b>name@label.com</b>.', 'info'); ta.focus(); return; }
    var batch = p.list.slice(0, MAX), cut = p.list.length - batch.length;
    setBusy(true);
    show('<ul class="ec2__list" aria-hidden="true">' + batch.map(function () { return '<li class="ec2__row ec2__row--sk"><i></i><i></i></li>'; }).join('') + '</ul>');
    var ac = 'AbortController' in window ? new AbortController() : null;
    var to = setTimeout(function () { if (ac) ac.abort(); }, TIMEOUT);
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ emails: batch }), credentials: 'omit', signal: ac ? ac.signal : undefined })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { return { r: r, b: b }; }); })
      .then(function (x) {
        clearTimeout(to); setBusy(false);
        if (x.r.status === 429) {
          // Retry-After is not exposed cross-origin (no Access-Control-Expose-Headers), so fall back to the error text.
          var ra = parseInt(x.r.headers.get('Retry-After'), 10), day = /day|tomorrow/i.test(x.b.error || '') || ra >= 3600;
          if (day) return msg('<b>That\'s today\'s 10 free checks.</b> Come back tomorrow, or <a href="/collections/all-access" data-link-source="email-checker">get lists that are already verified</a>.', 'warn');
          var sec = ra > 0 && ra < 3600 ? ra : 60;
          cooldown(sec);
          return msg('<b>Too many checks in a row.</b> Try again in about ' + sec + ' seconds. Your list is still in the box.', 'warn');
        }
        if (!x.r.ok || !x.b.results) return msg('<b>Something went wrong.</b> ' + esc(x.b.error || 'The checker did not answer properly.'), 'err', true);
        render(x.b, cut);
      })
      .catch(function () {
        clearTimeout(to); setBusy(false);
        msg('<b>Couldn\'t reach the checker.</b> Check your connection and try again.', 'err', true);
      });
  }

  ta.addEventListener('input', update);
  form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
  ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); run(); } });

  // methodology tooltip: same behaviour as the royalty calculator
  var ti = document.querySelector('.ec [data-tinfo]');
  if (ti) {
    var tb = ti.querySelector('button');
    var set = function (o) { ti.classList.toggle('is-open', o); tb.setAttribute('aria-expanded', o ? 'true' : 'false'); };
    tb.addEventListener('click', function (e) { e.stopPropagation(); set(!ti.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!ti.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }
  update();
})();
